import { US_COUNTRIES, AU_COUNTRIES } from "#lib/constants.js";

// The survey reward is €10, or $10 for US and AU visitors. One source for the
// symbol, so the banner, footer, product-page line and the modal cannot drift
// apart: before this the banner said "$10" to a US visitor and the modal it
// opened said "€10".
export function rewardSymbol(country) {
  return US_COUNTRIES.includes(country) || AU_COUNTRIES.includes(country)
    ? "$"
    : "€";
}
